import request from 'config/axios'

const URL = '/registrar/v2/customers/professionalinfo'
const URL_COUNTRIES = '/resources/v2/countries'

export const getBusinessInfo = () => request.get(URL)
export const getCountries = () => request.get(URL_COUNTRIES)
export const putBusinessInfo = ({ eletronicSignature, ...payload }) => {
  const data = { ...payload, electronicSignature: eletronicSignature }
  return request.put(URL, data)
}
